import { StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';
import {
    heightPercentageToDP,
    isWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    container: {
        marginTop: 20,
        marginBottom: 'auto',
    },
    itemContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: COLOR.COD_GRAY_LIGHT,
        paddingHorizontal: 16,
        borderRadius: 6,
        margin: 4,
        width: isWeb ? 640 : widthPercentageToDP(640),
        height: heightPercentageToDP(54),
    },
});

export default styles;
